var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mt-10 w-2/4 mx-auto bg-green-500"},[_c('product-widget')],1),_c('div',[_c('inc-dec',{model:{value:(_vm.qty),callback:function ($$v) {_vm.qty=$$v},expression:"qty"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }